export const waitingMessages = {
  firstMessage: 'Your xMatters experience will be ready in a minute!',
  secondMessage:
    'We’re still setting up your new instance – should just be another moment or two.',
  thirdMessage:
    'Sorry, it’s taking a little longer than expected! We’ll send you an email as soon as it’s ready.',
};
